import {
    IconPlayerPlayFilled,
    IconPlayerPauseFilled,
    IconChevronsLeft,
    IconChevronsRight,
} from "@tabler/icons-react";

const ICONS = {
    play: IconPlayerPlayFilled,
    pause: IconPlayerPauseFilled,
    back: IconChevronsLeft,
    forward: IconChevronsRight,
};

/**
 * PlayerFlash — transient on-video feedback for keyboard/click actions
 * ("-10s", "+10s", play/pause pulse). The parent keys it by flash id so a
 * repeated press restarts the fade-out animation.
 *
 * `persistent` keeps it on screen (no fade-out) — used as the click-to-play
 * affordance when the browser blocks unmuted autoplay.
 */
export default function PlayerFlash({ flash, persistent = false }) {
    const Icon = ICONS[flash.kind];
    if (!Icon) return null;

    const classes = [
        "player-flash",
        `player-flash--${flash.kind}`,
        persistent ? "player-flash--persistent" : "",
    ].join(" ").trim();

    return (
        <div className={classes} aria-hidden="true">
            {flash.kind === "forward" && flash.text && <span>{flash.text}</span>}
            <Icon />
            {flash.kind !== "forward" && flash.text && <span>{flash.text}</span>}
        </div>
    );
}
